import { getAllData } from 'apis/customApiHandler';
import AddPermissions from 'components/permissions/addPermissions';
import ViewPermissionsList from 'components/permissions/viewPermissionsList';
import useDebounce from 'hooks/useDebounce';
import { useState } from 'react';
import { useQuery } from 'react-query';
import { Button, Input } from 'styled';
import { TH } from 'styled/table';

const Permissions = () => {
  const [showAddmodel, setShowAddmodel] = useState(false);
  const [search, setSearch] = useState('');
  const debouncedValue = useDebounce(search, 1000);
  const { data: roles } = useQuery(
    ['roles', debouncedValue && debouncedValue],
    () => getAllData('/roles', { searchQuery: debouncedValue })
  );

  const { data: permissions } = useQuery(['permissions'], () =>
    getAllData('/permissions')
  );

  return (
    <div>
      <div className="m-10">
        <div className="mt-8 flex justify-start gap-6 items-center flex-wrap lg:flex-nowrap">
          <div className="relative w-full">
            <Input
              type="search"
              placeholder="Search Here"
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <Button bgPrimary onClick={() => setShowAddmodel(true)}>
            Add
          </Button>
        </div>
      </div>
      <div className="flex flex-col m-2 lg:m-10">
        <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <TH scope="col" className='whitespace-nowrap'>S.N.</TH>
                    <TH scope="col">Role Name</TH>
                    <TH scope="col">Permissions</TH>
                    <TH scope="col" className="whitespace-nowrap">Created At</TH>
                    <TH scope="col" className="whitespace-nowrap">Last Updated By</TH>
                    <TH scope="col">Actions</TH>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {roles?.data &&
                    roles?.data.map((role, index) => (
                      <ViewPermissionsList
                        role={role}
                        key={role._id}
                        index={index}
                        permissions={permissions?.data}
                      />
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {showAddmodel && (
        <AddPermissions handleClick={() => setShowAddmodel(false)} />
      )}
    </div>
  );
};

export default Permissions;
